import React from 'react';
import './ManufacturingSupply.css';

const ManufacturingSupply = () => {
  const services = [
    {
      id: 1,
      title: "Design & Engineering Support",
      items: [
        { title: "Custom System Design", description: "In-house design capabilities for mechanical and structural systems." },
        { title: "Structural Analysis", description: "Comprehensive stress testing and analysis." },
        { title: "Advanced Modeling", description: "CAD and 3D modelling services." },
        { title: "Prototype Development", description: "Prototyping and mock-ups for validation." }
      ]
    },
    {
      id: 2,
      title: "Quality Assurance",
      items: [
        { title: "Quality Control", description: "Rigorous quality control processes and standards." },
        { title: "Industry Compliance", description: "Adherence to industry standards and specifications." },
        { title: "Testing Protocols", description: "In-process inspections and final testing." },
        { title: "Certification", description: "Third Party witnessing and certification services." }
      ]
    },
    {
      id: 3,
      title: "Product Range and Specializations",
      items: [
        { title: "Industrial Machinery", description: "Valves, PRV Systems, Spray balls, Filters, and Pipelines." },
        { title: "HVAC Systems", description: "Design and supply of heating, ventilation, and air conditioning." },
        { title: "Steel Structures", description: "Frames, support beams, trusses, and custom products." },
        { title: "Prefabricated Structures", description: "Modular buildings and pre-assembled components." },
        { title: "Industrial Platforms", description: "Pipe supports, platforms, and scaffolding systems." }
      ]
    },
    {
      id: 4,
      title: "Industries Served",
      items: [
        { title: "Core Industries", description: "Oil & Gas, Automotive, Construction." },
        { title: "Process Industries", description: "Pharmaceutical, Power and Utilities." },
        { title: "Manufacturing", description: "Process Industries and General Manufacturing." }
      ]
    },
    {
      id: 5,
      title: "Research and Development (R&D)",
      items: [
        { title: "Technology Development", description: "New filtration and spray ball technologies." },
        { title: "Design Optimization", description: "Continuous testing and improvement." },
        { title: "Innovation", description: "Collaborative development with clients." }
      ]
    },
    {
      id: 6,
      title: "Maintenance and Support",
      items: [
        { title: "After-Sales Support", description: "Equipment maintenance, repair, and spare parts." },
        { title: "Supply Chain Services", description: "Global shipping and on-time delivery." },
        { title: "Installation Support", description: "Onsite installation and commissioning." },
        { title: "Service Contracts", description: "Long-term support packages and agreements." }
      ]
    }
  ];

  return (
    <>
      {/* Page Header */}
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Manufacturing and Supply</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Manufacturing and Supply Services Section */}
      <div className="bim-services">
        <div className="container">
          <div className="row">
            {services.map((service) => (
              <div key={service.id} className="col-lg-6 col-md-12">
                <div className="service-item">
                  <div className="service-header">
                    <div className="service-number">{String(service.id).padStart(2, '0')}</div>
                    <h3>{service.title}</h3>
                  </div>
                  <div className="service-content">
                    <ul>
                      {service.items.map((item, index) => (
                        <li key={index}>
                          <strong>{item.title}:</strong> {item.description}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ManufacturingSupply;
